export const teklifAlPage = (preSelectedType?: string) => {
  const isArac = ['trafik', 'kasko', 'imm', 'e-kasko'].includes(preSelectedType || '');

  return `
  <section class="page-content teklif-page">
    <div class="container">
      <div class="teklif-header">
        <h1 class="page-title">Teklif Al</h1>
        <p class="page-subtitle">Hızlı teklif almak için lütfen formu eksiksiz doldurun. En kısa sürede sizinle iletişime geçeceğiz.</p>
      </div>

      <div class="teklif-layout">
        <div class="teklif-form-section">
          <form class="teklif-form" id="teklifForm">

            <!-- 1. Önce sigorta tipi seçilsin -->
            <div class="form-group">
              <label for="teklifSigortaTipi">SİGORTA TİPİ *</label>
              <select id="teklifSigortaTipi" class="form-control" required>
                <option value="">Sigorta Tipi Seçin</option>
                <optgroup label="Araç Sigortaları">
                  <option value="trafik" ${preSelectedType === 'trafik' ? 'selected' : ''}>Zorunlu Trafik Sigortası</option>
                  <option value="kasko" ${preSelectedType === 'kasko' ? 'selected' : ''}>Kasko Sigortası</option>
                  <option value="imm" ${preSelectedType === 'imm' ? 'selected' : ''}>İMM (İhtiyari Mali Mesuliyet)</option>
                  <option value="e-kasko" ${preSelectedType === 'e-kasko' ? 'selected' : ''}>E-Kasko</option>
                </optgroup>
                <optgroup label="Konut ve İşyeri">
                  <option value="konut" ${preSelectedType === 'konut' ? 'selected' : ''}>Konut Sigortası</option>
                  <option value="dask" ${preSelectedType === 'dask' ? 'selected' : ''}>DASK (Deprem Sigortası)</option>
                  <option value="isyeri" ${preSelectedType === 'isyeri' ? 'selected' : ''}>İşyeri Sigortası</option>
                </optgroup>
                <optgroup label="Sağlık ve Hayat">
                  <option value="tamamlayici" ${preSelectedType === 'tamamlayici' ? 'selected' : ''}>Tamamlayıcı Sağlık</option>
                  <option value="ozel-saglik" ${preSelectedType === 'ozel-saglik' ? 'selected' : ''}>Özel Sağlık</option>
                  <option value="hayat" ${preSelectedType === 'hayat' ? 'selected' : ''}>Hayat Sigortası</option>
                  <option value="ferdi-kaza" ${preSelectedType === 'ferdi-kaza' ? 'selected' : ''}>Ferdi Kaza</option>
                </optgroup>
                <optgroup label="Diğer">
                  <option value="seyahat" ${preSelectedType === 'seyahat' ? 'selected' : ''}>Seyahat Sağlık</option>
                  <option value="nakliyat" ${preSelectedType === 'nakliyat' ? 'selected' : ''}>Nakliyat</option>
                  <option value="tarim" ${preSelectedType === 'tarim' ? 'selected' : ''}>Tarım / Hayvancılık</option>
                  <option value="diger" ${preSelectedType === 'diger' ? 'selected' : ''}>Diğer</option>
                </optgroup>
              </select>
            </div>

            <!-- 2. Kişisel bilgiler — her zaman göster -->
            <div class="form-row">
              <div class="form-group">
                <label for="teklifUnvan">ÜNVAN *</label>
                <input type="text" id="teklifUnvan" class="form-control" placeholder="Ad Soyad veya Firma Ünvanı" required>
              </div>
              <div class="form-group">
                <label for="teklifTcVergi">TC / VERGİ NUMARASI</label>
                <input type="text" id="teklifTcVergi" class="form-control" placeholder="TC/Vergi numaranızı giriniz" maxlength="11">
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="teklifTelefon">TELEFON *</label>
                <input type="tel" id="teklifTelefon" class="form-control" placeholder="Size ulaşabileceğimiz telefon numarası" required>
                <span class="form-hint">Size ulaşabileceğimiz telefon numaranızı giriniz.</span>
              </div>
              <div class="form-group">
                <label for="teklifEposta">E-POSTA *</label>
                <input type="email" id="teklifEposta" class="form-control" placeholder="E-posta adresiniz" required>
                <span class="form-hint">Kampanya ve bilgilendirmeler için email adresinizi giriniz.</span>
              </div>
            </div>

            <!-- 3. Araç alanları — sadece araç sigortası seçildiğinde göster -->
            <div id="aracAlanlari" class="form-row" style="display: ${isArac ? 'grid' : 'none'};">
              <div class="form-group">
                <label for="teklifPlaka">PLAKA *</label>
                <input type="text" id="teklifPlaka" class="form-control" placeholder="34 ABC 123">
                <span class="form-hint">Aracınızın plakasını yazınız.</span>
              </div>
              <div class="form-group">
                <label for="teklifBelgeSeri">BELGE SERİ NUMARASI *</label>
                <input type="text" id="teklifBelgeSeri" class="form-control" placeholder="Örn: AG 521438">
                <span class="form-hint">Ruhsatınızda isminizin yazılı olduğu sayfanın, sağ alt tarafındaki harf ve numaralardır.</span>
              </div>
            </div>

            <!-- 4. Mesaj — her zaman göster -->
            <div class="form-group">
              <label for="teklifMesaj">MESAJ / NOT</label>
              <textarea id="teklifMesaj" class="form-control" rows="3" placeholder="Eklemek istediğiniz bilgi veya notlar..."></textarea>
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" id="teklifSozlesme" required>
                <span><strong>Kullanım Sözleşmesini</strong> Okudum ve Onaylıyorum.</span>
              </label>
            </div>

            <div id="teklifError" class="error-message" style="display: none;"></div>
            <div id="teklifSuccess" class="success-message" style="display: none;"></div>

            <button type="submit" class="btn-primary btn-block">Teklif Al</button>
          </form>
        </div>

        <div class="teklif-sidebar">
          <div class="sidebar-card">
            <h3>Neden YILDIZ360?</h3>
            <ul>
              <li>20+ anlaşmalı sigorta şirketi</li>
              <li>Karşılaştırmalı fiyat teklifi</li>
              <li>Hızlı geri dönüş</li>
              <li>Ücretsiz danışmanlık</li>
              <li>7/24 destek hattı</li>
            </ul>
          </div>

          <div class="sidebar-card">
            <h3>Hemen Arayın</h3>
            <a href="tel:+905368949636" class="sidebar-phone">0536 894 96 36</a>
            <a href="https://wa.me/+905368949636" class="btn-outline sidebar-wa" target="_blank" rel="noopener">WhatsApp ile Ulaşın</a>
          </div>
        </div>
      </div>
    </div>
  </section>
`;
};
